import { apiClient } from '@/services/ApiClient.js'

export const getUnits = () => {
  return apiClient
    .get('units')
    .then(response => {
      return response
    })
    .catch(err => {
      throw err
    })
}

export default {
  getUnits
}
